import { useToast } from '../components/design-system/toaster'
import { useTranslationsStore } from './translationsStore'

const { toast } = useToast()

export const useToastStore = () => {
    const { translate } = useTranslationsStore()
    return {
        /**
         * @deprecated use new `useToast()` from the design system instead
         */
        openToast(type: 'red' | 'orange' | 'green', message: string): void {
            switch (type) {
                case 'red':
                    toast.error({
                        title: translate('general.error'),
                        description: message,
                    })
                    break
                case 'orange':
                    toast.warning({
                        title: translate('general.warning'),
                        description: message,
                    })
                    break
                case 'green':
                    toast.success({
                        title: translate('general.success'),
                        description: message,
                    })
                    break
            }
        },
    }
}
